<template>
    <div class="container" style="max-width: 532px !important;">
        <div class="magicAiLogin">
            <h2>Experience the <br> <span>Magic AI</span> Yourself</h2>
            <form @submit.prevent="ai_signup()">
                <h3 class="py-0">Unlock Free 20 Tokens From Us!</h3>

                <template v-if="click_verify">
                <input placeholder="Enter code sent to your email" type="text" class="form-control mt-3" v-model="form.isverify" v-validate="{ required: true, confirmed:otp }" name="isverify" :class="{ 'is-invalid': verrors.has('isverify') }" data-vv-as="Email OTP"> 
                <a href="javascript:void(0);" @click="verify_mail()" v-if="form.email"><small>Resend</small></a>
                <p v-if="verrors.has('isverify')" class="errormsg">{{ verrors.first('isverify') }} </p>
                </template>
                <template v-else>
                <input placeholder="Full Name" type="text" class="form-control mt-3" v-model="form.name" v-validate="'required|full_name'" name="name" :class="{ 'is-invalid': verrors.has('name') }">
                <p v-if="verrors.has('name')" class="errormsg">{{ verrors.first('name') }} </p>

                <input placeholder="Email Address" type="text" class="form-control mt-3" v-model="form.email" v-validate="'required|email'" name="email" :class="{ 'is-invalid': verrors.has('email') }">
                <p v-if="verrors.has('email')" class="errormsg">{{ verrors.first('email') }} </p>

                <input placeholder="Phone Number" type="text" class="form-control mt-3" v-model="form.phone" v-validate="'required'" name="phone" :class="{ 'is-invalid': verrors.has('phone') }">
                <p v-if="verrors.has('phone')" class="errormsg">{{ verrors.first('phone') }} </p>
                
                <select name="user_type" id="user_type" class="form-control mt-3" v-model="form.user_type" v-validate="'required'" :class="{ 'is-invalid': verrors.has('user_type') }" data-vv-as="User role">
                    <option value="">Are you a... </option>
                    <option value="Homeowner">Homeowner/Visitor</option>
                    <option value="Sales">Contractor</option>
                </select>
                <p v-if="verrors.has('user_type')" class="errormsg">{{ verrors.first('user_type') }} </p>

                <template v-if="form.user_type">
                <input :placeholder="form.user_type=='Sales'?'Type Your Pro ID':'Type Your Zip Code'" type="text" class="form-control mt-3" v-model="form.pro_id"  v-validate="{ required: true, confirmed: form.user_type === 'Sales' ? shop_id : false }" name="pro_id" :class="{ 'is-invalid': verrors.has('pro_id') }" :data-vv-as="form.user_type=='Sales'?'Pro ID':'Zip Code'">
                <p v-if="verrors.has('pro_id')" class="errormsg">{{ verrors.first('pro_id') }} </p>
                
                </template>

                <input placeholder="Create Password" type="password" class="form-control mt-3" v-model="form.password" v-validate="'required|min:8'" name="password" :class="{ 'is-invalid': verrors.has('password') }">
                <p v-if="verrors.has('password')" class="errormsg">{{ verrors.first('password') }} </p> 
                </template>
                
                <div class="buttonSec">
                    <div class="row align-items-center">
                        <div class="col-sm-8 pb-sm-0 pb-4">
                            <input type="checkbox" id="agree" v-model="form.agree" v-validate="'required'" name="agree" :class="{ 'is-invalid': verrors.has('agree') }">
                            <label for="agree">I agree to the WeVisu Privacy & Policy</label>
                            <p v-if="verrors.has('agree')" class="errormsg">{{ verrors.first('agree') }} </p>
                        </div>
                        <div class="col-sm-4"><button type="submit">Continue</button></div>
                    </div>
                    <router-link to="/design-ai/login">Already have an account? <span>Log-In</span></router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Validator } from "vee-validate";


import { mapActions, mapGetters } from "vuex";
import axios from "axios";  
export default {  
    name:'Signup',
    data() {
        return {
            click_verify:false,
            shop_id:shop_id,
            otp:'',
            form:{
                isverify:'',
                email: '',
                password: '',
                user_type: ''
            }
        };
    },
    created(){
        Validator.extend("full_name", {
      validate: (value) => {
        // Full Name Regex: At least two words with a space
        const fullNamePattern = /^[a-zA-Z]+ [a-zA-Z]+$/;
        return fullNamePattern.test(value.trim());
      },
      getMessage: () => "Please enter both first and last name.",
    });
    },
    watch: {
        Aiuser: {
             handler: function (newValue) {
                 if (newValue) {
                     if (this.Aiuser) { 
                             this.$router.push("/design-ai").catch(() => {}); 
                     }
                 }
             },
             deep: true
         }
     },
    computed: {
        ...mapGetters("auth", ["user"]),
        ...mapGetters("Aiauth", ["Aiuser"]),
        ...mapGetters({ 
            showroomId: "Common/MyItem", 
        }),
        ...mapGetters(["errors"]),
    },
   
    methods: {        
        ...mapActions("Aiauth", ["sendRegisterRequest" ]),
        verify_mail(){
            this.click_verify=true;

            let loader = this.$loading.show({ loader: 'dots' })   
            let form={
                shop_id : this.showroomId.showroom,
                email: this.form.email
            }
            
            axios.post('/api/AI/email_verify', form)
                .then((data) => {
                    loader.hide()
                    if (data.data.success) {
                        this.otp=data.data.data.otp
                        form = {};
                        this.$validator.reset(); 
                        Toast.fire({
                            icon: 'success',
                            title: data.data.message
                        });
                    } else{
                        Toast.fire({
                            icon: 'error',
                            title: data.data.message
                        });
                    }
                })
                .catch(err => {
                    loader.hide()
                })


            //this.otp=1234;
        },
        async ai_signup(){
            this.$validator.validateAll().then(async (valid) => {
                if (valid) { 
                    if(this.form.user_type=='Homeowner' && !this.click_verify){
                    this.verify_mail();
                    }else{
                    let loader = this.$loading.show({ loader: 'dots' })  
                    this.form.fAction="signup";
                    this.form.shop_id = this.showroomId.showroom
                    this.sendRegisterRequest(this.form).then(() => {
                        loader.hide()
                        if (this.Aiuser) { 
                            this.$router.push('/design-ai/');
                        }else{
                            this.$router.push('/design-ai/login');
                        }
                    }).catch(err => {
                        loader.hide()
                    })

                   
                    }
                }
            })
        }
    }
    
};

</script>
 